import React from "react";
import {
  FiHash as Hash,
  FiCalendar as Calendar,
  FiClock as Clock,
  FiGlobe as Globe,
  FiFlag as Flag,
  FiLink as LinkIcon,
  FiDollarSign as Dollar,
  FiLayers as Layers,
  FiCheckCircle as CheckCircle,
  FiXCircle as XCircle,
  FiUsers as UsersIcon,
} from "react-icons/fi";
import { Lounge } from "../../types/lounge.entity";

export const StatusIcon: React.FC<{ status: Lounge["status"] }> = ({ status }) => {
  if (status === "ACCEPTED") {
    return (
      <div className="relative">
        <CheckCircle className="w-5 h-5 text-emerald-500" />
        <div className="absolute inset-0 rounded-full bg-emerald-500/20 animate-pulse" />
      </div>
    );
  }
  if (status === "CANCELLED" || status === "EXPIRED") {
    return (
      <div className="relative">
        <XCircle className="w-5 h-5 text-red-500" />
        <div className="absolute inset-0 rounded-full bg-red-500/20" />
      </div>
    );
  }
  return (
    <div className="relative">
      <Layers className="w-5 h-5 text-amber-500" />
      <div className="absolute inset-0 rounded-full bg-amber-500/20" />
    </div>
  );
};
